import React, {Suspense} from 'react';
import { isMobile } from "../../App/utils";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
const LazySlider = React.lazy(() => import('react-slick'));

export const ScreenshotsCarousel = ({ screenshots }) => {
    const settings = {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 1,
        adaptiveHeight: true,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        responsive: [
            {breakpoint: 1920, settings: { slidesToShow: 5 }},
            {breakpoint: 1600, settings: { slidesToShow: 3 }},
            {breakpoint: 1200, settings: { slidesToShow: 2 }},
            {breakpoint: 1000, settings: { slidesToShow: 1 }},
        ]
    };

    // Custom arrow components to control positioning
    function SampleNextArrow(props) {
        const { className, style, onClick } = props;
        return (
            <div
                className={className}
                style={{ ...style, display: "block", right: isMobile ? undefined : "10px" }}
                onClick={onClick}
            />
        );
    }

    function SamplePrevArrow(props) {
        const { className, style, onClick } = props;
        return (
            <div
                className={className}
                style={{ ...style, display: "block", left: isMobile ? undefined : "10px", zIndex: 1 }}
                onClick={onClick}
            />
        );
    }

    return (
        <div style={{ margin: '20px 0', padding: '0 10px' }}>
            <Suspense fallback={<div></div>}>
                <LazySlider {...settings}>
                    {screenshots.map((screenshot, index) => (
                        <div key={index} style={{ padding: '0 5%' }}>
                            <img
                                src={screenshot}
                                alt={`Screenshot ${index + 1}`}
                                style={{
                                    maxWidth: isMobile ? '100%' : '90%',
                                    margin: '0 auto',
                                    display: 'block'
                                }}
                            />
                        </div>
                    ))}
                </LazySlider>
            </Suspense>
        </div>
    );
};
